// XDIV 0c day-0 conversion counters (marketing brief 2026-09-03, Owner-
// approved): the ONE counting ping the brief allows, the client half of the
// API's POST /v1/funnel/event. The body is exactly {kind, client: "web"} --
// no user id, no payload, no analytics SDK; the server stores (kind, client,
// timestamp) and nothing else. Fire-and-forget: callers never await it, it
// never blocks the UI, and a failed ping is swallowed. `keepalive` lets the
// paywall_view ping outlive the immediate navigation to Stripe behind it.
import { apiFetch } from "./client";

export type FunnelEventKind = "locked_slot_tap" | "paywall_view";

export function pingFunnel(kind: FunnelEventKind): void {
  apiFetch<void>("/v1/funnel/event", {
    method: "POST",
    body: { kind, client: "web" },
    keepalive: true,
  }).catch(() => {
    /* counting ping only -- a miss is never surfaced */
  });
}
